module.exports = __webpack_public_path__ + "fonts/BentonSansBBVA-BookItalic.428fac32.woff2";